import { useNavigate } from "react-router-dom";

import { theme } from "../../../assets";
import IconInstagram from "../../../assets/icons/icon-instagram";
import IconLinkedin from "../../../assets/icons/icon-linkedin";
import IconWhatsappFilled from "../../../assets/icons/icon-whatsapp-filled";
import MaintenanceMan from "../../../assets/images/maintenance-man";
import { redirectToWhatsApp } from "../../../utils/contact/redirect-to-whatsapp";
import * as s from "../styled-information-pages";

export const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <s.Container>
            <s.content>
                <MaintenanceMan
                    height="231px"
                    width="245px"
                    className="maintenanceMan"
                />
                <div className="contentSection">
                    <s.title>Página não encontrada</s.title>
                    <s.information>
                        <span>
                            A página não pode ser encontrada porque o endereço
                            está incorreto ou porque ela é privada
                        </span>
                        <span>
                            e você não tem acesso a ela. Em caso de dúvidas,
                            entre em contato conosco.
                        </span>
                    </s.information>
                    <s.button
                        onClick={() => {
                            navigate("/cronometro");
                        }}
                    >
                        VOLTAR
                    </s.button>
                </div>
                <s.footer>
                    <IconLinkedin
                        width="36px"
                        height="36px "
                        color={theme.purple600}
                        opacity="1"
                        cursor="pointer"
                        onClick={() => {
                            window.open(
                                "https://www.linkedin.com/company/paperonapp/",
                                "_blank"
                            );
                        }}
                    />
                    <IconInstagram
                        width="36px"
                        height="36px"
                        color={theme.purple600}
                        opacity="1"
                        cursor="pointer"
                        onClick={() => {
                            window.open(
                                "https://www.instagram.com/paperon.app/",
                                "_blank"
                            );
                        }}
                    />
                    <IconWhatsappFilled
                        width="36px"
                        height="36px"
                        color={theme.purple600}
                        cursor="pointer"
                        onClick={redirectToWhatsApp}
                    />
                </s.footer>
            </s.content>
        </s.Container>
    );
};
